import { Select, Input, Button, DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { DeleteOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";

const AddProposal = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [leadLoading, setLeadLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [userDetails, SetUserDetails] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [leads, setLeads] = useState([]);

  const [selectedType, setSelectedType] = useState("customer");

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [formData, setFormData] = useState({
    subject: "",
    content: "",

    rel_id: null,

    proposal_to: "",
    email: "",
    phone: "",

    address: "",
    city: "",
    state: "",
    zip: "",
    country: 1,

    date: dayjs(),

    status: 1,
  });

  const [billingDrawerOpen, setBillingDrawerOpen] = useState(false);
  const [shippingDrawerOpen, setShippingDrawerOpen] = useState(false);

  const [billingTemp, setBillingTemp] = useState({});
  const [shippingTemp, setShippingTemp] = useState({});

  const [staffList, setStaffList] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );

    SetUserDetails(userDetailsSession);

    setFormData((prev) => ({
      ...prev,
      sale_agent: userDetailsSession?.staffid || null,
    }));
  }, []);

  const getStaffDropdown = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data.Status) {
        setStaffList(data.ResultData || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      setCustomers(data.ResultData || []);
    } catch (error) {
      console.log(error);
    }
  };

  const getLeads = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeads`);

      const data = await response.json();

      setLeads(data.ResultData || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCustomers();
    getProducts();
    getStaffDropdown();
    getLeads();
  }, []);

  const getProducts = async () => {
    try {
      setProductLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}products/GetProducts`);

      const data = await response.json();

      setProducts(data.Data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setProductLoading(false);
    }
  };

  const handleCustomerChange = async (customerId) => {
    try {
      setCustomerLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length) {
        const customer = data.ResultData[0];

        setFormData((prev) => ({
          ...prev,

          // Proposal payload
          rel_id: customer.customerId,
          proposal_to: customer.company || "",
          email: customer.email || "",
          phone: customer.phonenumber || "",

          address: customer.address || "",
          city: customer.city || "",
          state: customer.state || "",
          zip: customer.zip || "",
          country: customer.country || 1,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const handleLeadChange = async (LeadId) => {
    try {
      setLeadLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}leads/GetLeadById?LeadId=${LeadId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData) {
        const lead = data.ResultData;
        setFormData((prev) => ({
          ...prev,

          // Proposal payload
          rel_id: lead.id,
          proposal_to: lead.name || "",
          email: lead.email || "",
          phone: lead.phonenumber || "",

          address: lead.address || "",
          city: lead.city || "",
          state: lead.state || "",
          zip: lead.zip || "",
          country: lead.country || 1,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLeadLoading(false);
    }
  };

  const handleProductSelect = (productId) => {
    const product = products.find((p) => p.id === productId);

    if (!product) return;

    const alreadyExists = selectedItems.some(
      (item) => item.item_id === product.id,
    );

    if (alreadyExists) return;

    setSelectedItems((prev) => [
      ...prev,
      {
        item_id: product.id,
        description: product.description,
        long_description: product.long_description,
        qty: 1,
        rate: Number(product.rate),
        tax: Number(product.tax || 0),
        unit: product.unit,
      },
    ]);
  };

  const updateQty = (index, qty) => {
    const items = [...selectedItems];

    items[index].qty = qty <= 0 ? 1 : qty;

    setSelectedItems(items);
  };

  const removeItem = (index) => {
    const items = [...selectedItems];

    items.splice(index, 1);

    setSelectedItems(items);
  };

  const subtotal = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate,
    0,
  );

  const totalTax = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate * (item.tax / 100),
    0,
  );

  const total = subtotal + totalTax;

  const openBillingDrawer = () => {
    setBillingTemp({
      billing_street: formData.billing_street,
      billing_city: formData.billing_city,
      billing_state: formData.billing_state,
      billing_zip: formData.billing_zip,
    });

    setBillingDrawerOpen(true);
  };

  const openShippingDrawer = () => {
    setShippingTemp({
      shipping_street: formData.shipping_street,
      shipping_city: formData.shipping_city,
      shipping_state: formData.shipping_state,
      shipping_zip: formData.shipping_zip,
    });

    setShippingDrawerOpen(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        subject: formData.subject,
        content: formData.content,

        addedfrom: userDetails.staffid,
        assigned: userDetails.staffid,

        subtotal,
        total_tax: totalTax,
        total,
        adjustment: 0,

        rel_id: formData.rel_id, // Customer ID or Lead ID
        rel_type: selectedType, // "customer" or "lead"

        proposal_to: formData.proposal_to,

        open_till: formData.date ? formData.date.format("YYYY-MM-DD") : null,
        country: formData.country,
        zip: formData.zip,
        state: formData.state,
        city: formData.city,
        address: formData.address,

        email: formData.email,
        phone: formData.phone,

        status: formData.status,

        items: selectedItems.map((item) => ({
          item_id: item.item_id,
          description: item.description,
          long_description: item.long_description,
          qty: item.qty,
          rate: item.rate,
          unit: item.unit,
        })),
      };

      console.log("Proposal Payload:", JSON.stringify(payload, null, 2));

      const response = await fetch(`${API_BASE_CRM_URL}proposal/AddProposal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
          timerProgressBar: true,
        });

        setTimeout(() => {
          navigate("/proposal");
        }, 1500);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Failed to create proposal",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Base>
      <div className="row align-items-center mb-2">
        <div className="col-8">
          <div className="page-title">
            <h4>Add Proposal</h4>
          </div>
        </div>
        <div className="col-4 d-flex justify-content-end">
          <Link to="/proposal">
            <button className="btn btn-sm btn-secondary">
              <i className="fa-solid fa-list"></i>
            </button>
          </Link>
        </div>
      </div>
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-4">
              <Select
                className="w-100"
                size="large"
                value={selectedType}
                onChange={(value) => {
                  setSelectedType(value);
                  setSelectedCustomer(null);
                  setSelectedLead(null);
                }}
                options={[
                  { value: "customer", label: "Customer" },
                  { value: "lead", label: "Lead" },
                ]}
              />
            </div>

            <div className="col-8">
              {selectedType === "customer" ? (
                <Select
                  showSearch
                  className="w-100"
                  size="large"
                  placeholder="Select Customer"
                  value={selectedCustomer}
                  onChange={(value) => {
                    setSelectedCustomer(value);
                    handleCustomerChange(value);
                  }}
                  options={customers.map((customer) => ({
                    value: customer.customerId,
                    label: customer.company,
                  }))}
                />
              ) : (
                <Select
                  showSearch
                  className="w-100"
                  size="large"
                  placeholder="Select Lead"
                  value={selectedLead}
                  onChange={(value) => {
                    setSelectedLead(value);
                    handleLeadChange(value);
                  }}
                  options={leads.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                />
              )}
            </div>
            <div className="col-6">
              <Select
                className="w-100"
                size="large"
                value={formData.status}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    status: value,
                  })
                }
                options={[
                  {
                    label: "Draft",
                    value: 1,
                  },
                  {
                    label: "Sent",
                    value: 2,
                  },
                  {
                    label: "Expired",
                    value: 3,
                  },
                  {
                    label: "Declined",
                    value: 4,
                  },
                  {
                    label: "Accepted",
                    value: 5,
                  },
                ]}
              />
            </div>
            {/* <div className="col-6">
              <Input
                size="large"
                addonBefore={<span className="fw-bold text-primary">EST</span>}
                placeholder="Estimate Number"
                value={formData.number}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    number: e.target.value,
                  })
                }
              />
            </div> */}
            {/* <div className="col-6">
              <DatePicker
                size="large"
                className="w-100"
                format="DD-MM-YYYY"
                value={formData.date}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    date: value,
                  })
                }
              />
            </div>
            <div className="col-6">
              <DatePicker
                size="large"
                className="w-100"
                value={formData.expirydate}
                disabledDate={(current) =>
                  current && current.isBefore(formData.date.startOf("day"))
                }
              />
            </div> */}
            <div className="col-6">
              <Select
                className="w-100"
                size="large"
                placeholder="Select Sale Agent"
                value={formData.sale_agent}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    sale_agent: value,
                  }))
                }
                options={staffList.map((staff) => ({
                  value: staff.staffid,
                  label: `${staff.firstname} ${staff.lastname}`,
                }))}
                // suffixIcon={<i className="fas fa-user-tie"></i>}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-header bg-white">
          <strong>
            <i className="fas fa-address-card me-2 text-primary"></i>
            Proposal Details
          </strong>
        </div>

        <div className="card-body">
          <div className="row g-3">
            <div className="col-12">
              <Input
                size="large"
                placeholder="Enter Subject"
                value={formData.subject}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    subject: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-12">
              <DatePicker
                size="large"
                className="w-100"
                format="DD-MM-YYYY"
                value={formData.date}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    date: value,
                  })
                }
              />
            </div>

            <div className="col-12">
              <Input
                size="large"
                placeholder="Email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-12">
              <Input
                size="large"
                placeholder="Phone"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    phone: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-6">
              <Input
                size="large"
                placeholder="Address"
                value={formData.address}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    address: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-6">
              <Input
                size="large"
                placeholder="City"
                value={formData.city}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    city: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-6">
              <Input
                size="large"
                placeholder="State"
                value={formData.state}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    state: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-6">
              <Input
                size="large"
                placeholder="Zip Code"
                value={formData.zip}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    zip: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-12">
              <label className="form-label">Proposal Content</label>
              <Input.TextArea
                rows={5}
                placeholder="Proposal Content"
                value={formData.content}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    content: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <strong className="mb-1">
            <i className="fas fa-box me-2 text-warning"></i>
            Products
          </strong>
          <Select
            showSearch
            size="large"
            className="w-100"
            placeholder="Select Product"
            onChange={handleProductSelect}
            options={products.map((product) => ({
              value: product.id,
              label: product.description,
            }))}
          />
        </div>
      </div>

      {selectedItems.map((item, index) => {
        const amount = item.qty * item.rate;
        const taxAmount = amount * (item.tax / 100);

        return (
          <div key={item.item_id} className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              {/* Header */}

              <div className="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <h5 className="mb-1 fw-semibold">{item.description}</h5>
                </div>

                <Button
                  danger
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </div>

              {/* Qty */}

              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="fw-medium">Quantity</span>

                <div className="input-group" style={{ width: 130 }}>
                  <button
                    className="btn btn-light border"
                    type="button"
                    onClick={() => updateQty(index, Math.max(1, item.qty - 1))}
                  >
                    <i className="fas fa-minus"></i>
                  </button>

                  <input
                    className="form-control text-center"
                    value={item.qty}
                    readOnly
                  />

                  <button
                    className="btn btn-light border"
                    type="button"
                    onClick={() => updateQty(index, item.qty + 1)}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <hr className="m-1" />

              {/* Summary */}

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Rate</span>

                <span className="fw-medium">₹ {item.rate}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Tax</span>

                <span className="fw-medium">{item.tax}%</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Subtotal</span>

                <span className="fw-medium">₹ {amount.toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between">
                <span className="fw-semibold">Total</span>

                <span className="fw-bold text-success">
                  ₹ {(amount + taxAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        );
      })}

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-2">
            <span>Subtotal</span>
            <strong>₹ {subtotal.toFixed(2)}</strong>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Tax</span>
            <strong>₹ {totalTax.toFixed(2)}</strong>
          </div>

          <hr />

          <div className="d-flex justify-content-between">
            <h5>Total</h5>
            <h5 className="text-success">₹ {total.toFixed(2)}</h5>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          className="btn btn-secondary btn-sm mt-3"
          onClick={handleSubmit}
          type="button"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
              Saving...
            </>
          ) : (
            <>
              <i className="fas fa-save me-2"></i>
              Save
            </>
          )}
        </button>
      </div>

      <Footer />
    </Base>
  );
};

export default AddProposal;
